import { Skeleton } from '@/components/ui/skeleton'
import { useTile } from '../../context'
import TileRenderer from '../TileRenderer'
import TileWrapper from '../TileWrapper'
import { skeletonHeightByTileType } from 'app/frontend/types/custom/OverviewTileType'

export const SIDEBAR_TILE_SLOTS = ['tile_1', 'tile_2', 'tile_3'] as const

export const SidebarTilesTileContent = ({ loading }: { loading?: boolean }) => {
  const { tile } = useTile()

  return (
    <div
      className={`grid grid-cols-1 sm:grid-cols-2 ${
        tile.config?.tile_3 ? 'md:grid-cols-3' : ''
      } gap-4`}
    >
      {SIDEBAR_TILE_SLOTS.map((slot, order) => {
        const childTileType = tile.config?.[slot]
        if (!childTileType) return null

        return loading ? (
          <Skeleton
            key={slot}
            className={skeletonHeightByTileType['Tile::SidebarTiles']}
          />
        ) : (
          <TileRenderer
            key={slot}
            index={order}
            tile={{
              type: childTileType,
              position: 'sidebar',
              config: tile.config?.[`${slot}_config`] || {},
              order,
              accessLevel: tile.accessLevel,
              readonly: true,
            }}
          />
        )
      })}
    </div>
  )
}

const SidebarTilesTile = () => {
  return (
    <TileWrapper inContainer={false}>
      <SidebarTilesTileContent />
    </TileWrapper>
  )
}

export default SidebarTilesTile
